import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined"
import PrimaryButton from "newcomponents/primary-button"

const ConfirmationModal = ({
  isOpen,
  toggle,
  mode = "light",
  title = "Confirmation",
  messageTitle = "Are you sure you want to proceed?",
  messageSubtitle = "",
  confirmText = "Confirm",
  cancelText = "Cancel",
  icon: Icon, // ✅ Accept custom icon component
  iconColor,
  onConfirm,
  onCancel,
}) => {
  const defaultIconColor = mode === "dark" ? "#fff" : "#2990DF"

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      style={{ maxWidth: "500px" }}
    >
      <div
        style={{
          backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
          borderRadius: "12px",
          padding: "0",
        }}
      >
        {/* Header */}
        <ModalHeader
          toggle={toggle}
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            color: mode === "dark" ? "#fff" : "#000",
            fontWeight: "600",
            fontSize: "18px",
            borderBottom:
              mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
            paddingBottom: "16px",
          }}
        >
          {title}
        </ModalHeader>

        {/* Body */}
        <ModalBody
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            textAlign: "center",
            padding: "30px 40px",
          }}
        >
          <div
            style={{
              width: "120px",
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
            }}
          >
            {Icon ? (
              <Icon
                style={{
                  fontSize: "80px",
                  color: iconColor || defaultIconColor,
                }}
              />
            ) : (
              // fallback icon if none provided
              <DoneOutlinedIcon
                style={{ fontSize: "80px", color: defaultIconColor }}
              />
            )}
          </div>

          <h5
            style={{
              color: mode === "dark" ? "#fff" : "#000",
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "12px",
            }}
          >
            {messageTitle}
          </h5>

          <p
            style={{
              color: mode === "dark" ? "#9ca3af" : "#666",
              fontSize: "12px",
              marginBottom: "0",
            }}
          >
            {messageSubtitle}
          </p>
        </ModalBody>

        {/* Footer */}
        <ModalFooter
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            justifyContent: "center",
            gap: "12px",
            borderTop:
              mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
          }}
        >
          <PrimaryButton
            onClick={onCancel || toggle}
            style={{
              backgroundColor: "white",
              border:
                mode === "dark" ? "1px solid #374151" : "1px solid #e0e0e0",
              color: "#000",
              fontSize: "14px",
              fontWeight: "500",
              width: "166px",
              height: "46px",
              borderRadius: "5px",
            }}
          >
            {cancelText}
          </PrimaryButton>

          <PrimaryButton
            onClick={onConfirm}
            style={{
              backgroundColor: "#2990DF",
              color: "#fff",
              fontSize: "14px",
              fontWeight: "500",
              border: "none",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "166px",
              height: "46px",
              borderRadius: "5px",
              textTransform: "none",
              padding: "0 10px",
            }}
          >
            {confirmText}
            <DoneOutlinedIcon style={{ fontSize: "18px" }} />
          </PrimaryButton>
        </ModalFooter>
      </div>
    </Modal>
  )
}

export default ConfirmationModal
